import * as types from "./actionTypes";
export function setDropped(droppedItem) {
	return { type: types.SET_DROPPED, droppedItem };
}

export function updateDroppedItems(dropped) {
	return { type: types.UPDATE_DROPPED_ITEMS, dropped };
}

export function removeDropItem(uid) {
	return { type: types.REMOVE_DROP_ITEM, uid };
}
export function setEditingMode(fieldId, fieldType = "INPUT_FIELD") {
	return { type: types.SET_EDITING_MODE, payload: { fieldId, fieldType } };
}
export function setFormTitle(title) {
	return { type: types.SET_FORM_TITLE, payload: { title } };
}

export function setFormDescription(description) {
	return { type: types.SET_FORM_DESCRIPTION, payload: { description } };
}

export function updateField(updateField, fieldType = "INPUT_FIELD") {
	return { type: types.UPDATE_FIELD, payload: { updateField, fieldType } };
}

export function disableEditingMode() {
	return { type: types.DISABLE_EDITING_MODE };
}

export function updateEntireForms(payload) {
	return { type: types.UPDATE_ENTIRE_FORMS, payload };
}
